let waitWindowLoad;
if (typeof window !== 'undefined') {
  if (typeof Promise !== 'undefined') {
    waitWindowLoad = new Promise(resolve => window.addEventListener('load', resolve))
  } else {
    waitWindowLoad = { then: (cb) => window.addEventListener('load', cb) }
  }
}

export function register (swUrl, hooks = {}) {
  const { registrationOptions = {} } = hooks;
  delete hooks.registrationOptions;

  const emit = (hook, ...args) => {
    if (hooks && hooks[hook]) {
      hooks[hook](...args);
    }
  }

  if ('serviceWorker' in navigator) {
    waitWindowLoad.then(() => {
      registerValidSW(swUrl, emit, registrationOptions);
    })
  }
}

function handleError (emit, error) {
  if (!navigator.onLine) {
    emit('offline');
  }
  emit('error', error);
}

function registerValidSW (swUrl, emit, registrationOptions) {
  navigator.serviceWorker
    .register(swUrl, registrationOptions)
    .then(registration => {
      if (registration.waiting) {
        emit('updated', registration);
        return;
      }
      registration.onupdatefound = () => {
        emit('updatefound', registration)
        const installingWorker = registration.installing
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              emit('updated', registration);
            } else {
              emit('cached', registration);
            }
          }
        }
      }
      // Fire registered hook after onupdatefound is wired up,
      // so registration.update() calls don't miss the handler.
      emit('registered', registration)
    })
    .catch(error => handleError(emit, error));
}

export function unregister (emit) {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    }).catch(error => handleError(emit, error));
  }
}
